module.exports = "/_next/static/images/4fdaf7345df74b640ab1c207f4e393dc-money-grow.svg.webp";